import { useParams } from 'react-router-dom';
import { LeadEditor, LeadHeader } from './components';
import { useMemo } from 'react';
import { convertLeadApiResponseToLead } from 'utils/lead';
import useLead from './hooks/useLead';
import useQueryParams from 'hooks/useQueryParams';

import './Lead.styles.scss';

const LeadPage = () => {
  const { id } = useParams<{ id: string }>();
  const { params } = useQueryParams();

  const { data, isLoading, isError } = useLead(id, !!params?.campaignType);

  const lead = useMemo(
    () => data && convertLeadApiResponseToLead(data),
    [data],
  );

  if (isError) return <div>Error loading lead data.</div>;
  return (
    <div className="lead-page">
      <LeadHeader lead={lead} isLoading={isLoading} />
      <div className="lead-page__content">
        {!!lead && !isLoading && (
          <LeadEditor id={id} isPersonal={!!params?.campaignType} />
        )}
      </div>
    </div>
  );
};

export default LeadPage;
